var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('head-content',{attrs:{"details":_vm.details,"reasonList":_vm.reasonList,"productIds":_vm.productIds},on:{"refresh":_vm.getDetail}}),_c('box-content',{attrs:{"rowId":_vm.rowId}}),_c('base-content',{attrs:{"details":_vm.details}}),_c('formula-additional-raw',{attrs:{"rowId":_vm.rowId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }